import React from 'react'
import AnimatedNavbar from '../../layouts/Header/components/AnimatedNavbar/AnimatedNavbar'

const TooltipDropdown = ({
  trigger,
  children,
  duration = 100,
  containerStyle = {},
  caretStyle = {},
  showCaret = true,
  className = '',
}) => {
  const defaultContainerStyle = {
    top: '0px',
    marginRight: '0px',
    ...containerStyle,
  }

  const defaultCaretStyle = {
    marginLeft: '76%',
    display: showCaret ? 'block' : 'none',
    marginTop: '0px',
    ...caretStyle,
  }

  return (
    <div className={`flex  items-center relative z-[9999999] gap-2 p-[3px] ${className}`}>
      <AnimatedNavbar
        duration={duration}
        navbarConfig={[
          {
            item: trigger,
            dropdown: (
              <div className="bg-white rounded-xl shadow-lg border border-zinc-200 dark:border-zinc-800 dark:bg-zinc-900 overflow-hidden">
                {children}
              </div>
            ),
            containerStyle: defaultContainerStyle,
            caretStyle: defaultCaretStyle,
          },
        ]}
      />
    </div>
  )
}

export default TooltipDropdown
